import { render, staticRenderFns } from "./CommercialPrudenceDashboard.vue?vue&type=template&id=3b3e1f6b"
import script from "./CommercialPrudenceDashboard.vue?vue&type=script&lang=ts"
export * from "./CommercialPrudenceDashboard.vue?vue&type=script&lang=ts"
import style0 from "./CommercialPrudenceDashboard.vue?vue&type=style&index=0&id=3b3e1f6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports